/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description GuarantorUnallocatedAmountActions
 */
import { Dropdown } from 'antd';
import { MoreOne } from '@icon-park/react';
import { useNavigate } from 'react-router-dom';
import { MenuItemType } from 'antd/es/menu/interface';

import Button from '.';
import { defaultDropdownButtonProps } from './ClaimTableActions';
import { getPaymentsPath } from 'utils/router';
import { ALLOCATION_MODES } from 'app-constants/payments';

export interface IProps {
	data: Guarantor.IGuarantorResponse;
}

const GuarantorUnallocatedAmountActions: React.FC<IProps> = ({ data }) => {
	const navigate = useNavigate();
	const schema: MenuItemType[] = [
		{
			key: 'allocate',
			label: 'Allocate',
			onClick: () => {
				navigate(getPaymentsPath({ tab: ALLOCATION_MODES.unallocated.value, guarantorId: data?.id }));
			},
		},
		{
			key: 'refund',
			className: 'tw-dropdown-menu-item',
			label: <Button.GuarantorRefund data={data} {...defaultDropdownButtonProps} />,
		},
	];

	return (
		<Dropdown menu={{ items: schema }} trigger={['hover']}>
			<Button icon={<MoreOne />} />
		</Dropdown>
	);
};

export default GuarantorUnallocatedAmountActions;
